<div class="pages">

    <h4 class="text-left p-3">{{ slider.title }} </h4>
    <hr>
    <div class="divider"></div>   
    
     <div class="p-3" innerHTML="{{slider.content}}"></div>
     
 
     <br>
 
 
 
 </div>